import React from 'react';
import { downloadLink } from '../../helpers/constFIles';
import './Chat.scss';

/* An avatar with the green dot on it. The dot is part of the avatar rather
   than a separate element beside it, so it stays put wherever the avatar is
   used — the team list, the thread header, a popup title bar. */
const PresenceAvatar = ({ person = {}, online = false, size = 40, showDot = true }) => {
    const name = person.employeeName || person.employeeCode || '?';
    const initial = String(name).trim().charAt(0).toUpperCase() || '?';
    const photo = person.profilePic ? downloadLink + person.profilePic : '';

    /* A stable colour per person, so the same face keeps the same tile
       between sessions instead of changing on every render. */
    const hues = ['#2b8fe0', '#6d4bb8', '#0f9d63', '#c8811a', '#d9614f', '#1c4f86'];
    const key = String(person.employeeCode || name);
    let sum = 0;
    for (let i = 0; i < key.length; i += 1) sum += key.charCodeAt(i);
    const background = hues[sum % hues.length];

    return (
        <span
            className={`chat-avatar${online ? ' is-online' : ''}`}
            style={{ width: size, height: size, '--chat-avatar-size': `${size}px` }}
        >
            {photo
                ? <img src={photo} alt={name} />
                : <span className="chat-avatar-initial" style={{ background }}>{initial}</span>}
            {showDot && <i className="chat-avatar-dot" aria-hidden="true" />}
        </span>
    );
};

export default PresenceAvatar;
